const PageNotAvailable = () => {

    return (
        <div className="text-white text-center"> 
            Updating...
        </div>
    )
}

export default PageNotAvailable